import { useState } from 'react';
import { useNavigate, Link } from 'react-router-dom';
import api from '../api';
import AuthLayout from '../components/AuthLayout';

export default function Register() {
  const [form, setForm]       = useState({ nombre_empresa: '', nit_o_documento: '', correo: '', password: '', confirmar: '' });
  const [error, setError]     = useState('');
  const [loading, setLoading] = useState(false);
  const [focused, setFocused] = useState('');
  const navigate  = useNavigate();

  const submit = async (e) => {
    e.preventDefault();
    if (form.password !== form.confirmar) { setError('Las contraseñas no coinciden'); return; }
    if (form.password.length < 6) { setError('La contraseña debe tener al menos 6 caracteres'); return; }
    setError(''); setLoading(true);
    try {
      const r = await api.post('/auth/register', {
        nombre_empresa:  form.nombre_empresa,
        nit_o_documento: form.nit_o_documento,
        correo:          form.correo,
        password:        form.password,
      });
      navigate('/verificar', {
        state: {
          cliente_id:     r.data.cliente_id,
          nombre_empresa: r.data.nombre_empresa,
          correo:         form.correo,
        }
      });
    } catch (err) {
      setError(err.response?.data?.detail || 'Error creando la cuenta');
    } finally { setLoading(false); }
  };

  const inputStyle = (isFocused, extra) => ({
    width: '100%', padding: '11px 14px', background: 'var(--surface-3)',
    border: `1px solid ${isFocused ? 'var(--accent-solid)' : 'var(--surface-2)'}`,
    boxShadow: isFocused ? '0 0 0 3px var(--accent-soft)' : 'none',
    borderRadius: 10, color: 'var(--text)', fontSize: 14, outline: 'none',
    fontFamily: 'Inter,sans-serif', transition: 'border-color .2s, box-shadow .2s',
    ...extra,
  });

  const labelStyle = { fontSize: 11, color: 'var(--text-3)', textTransform: 'uppercase', letterSpacing: '.08em', display: 'block', marginBottom: 7 };

  return (
    <AuthLayout>
      {/* Card — Liquid Glass */}
      <div className="ic-reveal" style={{
        position: 'relative', zIndex: 2,
        background: 'var(--glass)',
        border: '1px solid var(--glass-brd)',
        borderRadius: 22, padding: '38px 40px',
        width: '100%', maxWidth: 460,
        WebkitBackdropFilter: 'blur(28px) saturate(1.6)', backdropFilter: 'blur(28px) saturate(1.6)',
        boxShadow: '0 30px 90px rgba(0,0,0,0.45), inset 0 1px 0 var(--glass-hi)',
        animationDelay: '0.18s',
      }}>
        <h1 style={{ fontFamily: 'Inter,sans-serif', fontSize: 24, fontWeight: 800, color: 'var(--text)', marginBottom: 6, textAlign: 'center' }}>
          Crea tu cuenta
        </h1>
        <p style={{ fontSize: 13, color: 'var(--text-3)', marginBottom: 24, textAlign: 'center' }}>
          Empieza gratis · Sin tarjeta de crédito
        </p>

        {error && (
          <div style={{ padding: '11px 14px', background: 'var(--danger-soft)', border: '1px solid var(--danger-soft)', borderRadius: 10, fontSize: 13, color: 'var(--danger)', marginBottom: 18 }}>
            {error}
          </div>
        )}

        <form onSubmit={submit}>
          <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 12, marginBottom: 14 }}>
            <div>
              <label style={labelStyle}>Empresa</label>
              <input value={form.nombre_empresa} onChange={e => setForm({ ...form, nombre_empresa: e.target.value })}
                required placeholder="Mi Empresa S.A.S"
                style={inputStyle(focused === 'empresa')}
                onFocus={() => setFocused('empresa')} onBlur={() => setFocused('')} />
            </div>
            <div>
              <label style={labelStyle}>NIT / Doc.</label>
              <input value={form.nit_o_documento} onChange={e => setForm({ ...form, nit_o_documento: e.target.value })}
                required placeholder="900123456-1"
                style={inputStyle(focused === 'nit')}
                onFocus={() => setFocused('nit')} onBlur={() => setFocused('')} />
            </div>
          </div>

          <div style={{ marginBottom: 14 }}>
            <label style={labelStyle}>Correo electrónico</label>
            <input type="email" value={form.correo} onChange={e => setForm({ ...form, correo: e.target.value })}
              required placeholder="tu@empresa.com"
              style={inputStyle(focused === 'correo')}
              onFocus={() => setFocused('correo')} onBlur={() => setFocused('')} />
          </div>

          <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 12, marginBottom: 24 }}>
            <div>
              <label style={labelStyle}>Contraseña</label>
              <input type="password" value={form.password} onChange={e => setForm({ ...form, password: e.target.value })}
                required placeholder="Mín. 6 caracteres"
                style={inputStyle(focused === 'pass')}
                onFocus={() => setFocused('pass')} onBlur={() => setFocused('')} />
            </div>
            <div>
              <label style={labelStyle}>Confirmar</label>
              <input type="password" value={form.confirmar} onChange={e => setForm({ ...form, confirmar: e.target.value })}
                required placeholder="Repite la contraseña"
                style={inputStyle(focused === 'confirm', form.confirmar && form.confirmar !== form.password ? { borderColor: 'var(--danger)' } : {})}
                onFocus={() => setFocused('confirm')} onBlur={() => setFocused('')} />
            </div>
          </div>

          {form.confirmar && (
            <div style={{ fontSize: 11, marginBottom: 16, marginTop: -18, color: form.password === form.confirmar ? 'var(--success)' : 'var(--danger)' }}>
              {form.password === form.confirmar ? '✓ Las contraseñas coinciden' : '✗ Las contraseñas no coinciden'}
            </div>
          )}

          <button type="submit" disabled={loading} style={{
            width: '100%', padding: '13px', borderRadius: 12, border: 'none',
            background: loading ? 'var(--surface-2)' : 'linear-gradient(135deg,var(--accent-solid),var(--accent-2))',
            color: loading ? 'var(--text-3)' : '#fff', fontSize: 15, fontWeight: 700,
            cursor: loading ? 'not-allowed' : 'pointer',
            boxShadow: loading ? 'none' : '0 6px 24px rgba(124,58,237,0.4)',
            transition: 'transform 0.2s ease, box-shadow 0.2s ease',
          }}
            onMouseEnter={e => { if (!loading) { e.currentTarget.style.transform = 'translateY(-2px)'; e.currentTarget.style.boxShadow = '0 10px 32px rgba(124,58,237,0.55)'; } }}
            onMouseLeave={e => { e.currentTarget.style.transform = 'none'; e.currentTarget.style.boxShadow = loading ? 'none' : '0 6px 24px rgba(124,58,237,0.4)'; }}
          >
            {loading ? 'Creando cuenta...' : 'Crear cuenta gratis →'}
          </button>
        </form>

        <p style={{ textAlign: 'center', marginTop: 20, fontSize: 13, color: 'var(--text-3)' }}>
          ¿Ya tienes cuenta?{' '}
          <Link to="/login" style={{ color: 'var(--accent-solid)', textDecoration: 'none', fontWeight: 600 }}>
            Inicia sesión
          </Link>
        </p>
      </div>
    </AuthLayout>
  );
}
